import axios from "axios";
import { API_BASE_URL } from "../utilities";

const h = () => ({ Authorization: localStorage.getItem("token") });

export const saveMessageApi = (data) =>
  axios.post(API_BASE_URL + "chatbot/message/save/", data, { headers: h() });

export const sendChatMessageApi = (session_id, message) =>
  axios.post(API_BASE_URL + "chatbot/chat/", { session_id, message }, { headers: h() });

export const getQuickQuestionsApi = () =>
  axios.get(API_BASE_URL + "chatbot/quick-questions/", { headers: h() });

export const getSessionsApi = () =>
  axios.get(API_BASE_URL + "chatbot/sessions/", { headers: h() });

export const getSessionMessagesApi = (session_id) =>
  axios.get(API_BASE_URL + `chatbot/session/${session_id}/messages/`, { headers: h() });

export const raiseTicketApi = (data) =>
  axios.post(API_BASE_URL + "chatbot/ticket/raise/", data, { headers: h() });

export const getTicketStatusApi = (ticket_id) =>
  axios.get(API_BASE_URL + `chatbot/ticket/${ticket_id}/`, { headers: h() });

export const getMyTicketsApi = () =>
  axios.get(API_BASE_URL + "chatbot/tickets/", { headers: h() });

export const getTokenUsageApi = () =>
  axios.get(API_BASE_URL + "chatbot/token-usage/", { headers: h() });

export const submitMessageFeedbackApi = (message_id, feedback, note = "") =>
  axios.post(
    API_BASE_URL + `chatbot/message/${message_id}/feedback/`,
    { feedback, note },
    { headers: h() }
  );

export const uploadChatAttachmentApi = (session_id, file) => {
  const formData = new FormData();
  formData.append("session_id", session_id);
  formData.append("file", file);
  return axios.post(API_BASE_URL + "chatbot/attachment/upload/", formData, {
    headers: { ...h(), "Content-Type": "multipart/form-data" },
  });
};
